<cap-form-row>
  <div class="col-md-12">
    <h3 class="title-divider">{{ "bearbeitetstatusHeading" | translate }}</h3>
  </div>
  <cap-form-control column-classes="col-md-3,col-md-9" labelKey="Bearbeitet">
    <input
      (ngModelChange)="model && (model.bearbeitet = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.bearbeitet"
      id="bearbeitet"
      name="status"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control column-classes="col-md-3,col-md-9" labelKey="NichtBearbeitet">
    <input
      (ngModelChange)="model && (model.nichtBearbeitet = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.nichtBearbeitet"
      id="nichBearbeitet"
      name="status"
      type="checkbox" />
  </cap-form-control>
</cap-form-row>
